import React, { useContext, useMemo, useState } from 'react'
import { TextField, Autocomplete, IconButton } from "@mui/material"
import { LoadingContext } from '../M_Utils'
import { useTranslation } from 'react-i18next'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { useRegisterFavorite } from '../M_FormFavorites/FavoritesContext'

export function M_InputTextField({ label, type, value, onChange, disabled, maxNumbers,
    required, color, secondColor, size, placeholder, InputProps, onKeyDown, height,
    padding, paddingLeft, paddingRight, paddingTop, paddingBottom, margin, backgroundColor,
    options, labelFields, onChangeValue, iconStart, iconEnd, className, onBlur, disabledColor,
    style, submit, cancel, translate, renderOption, endAdornment, onOpen, filterOptions,
    favoritesFieldName, favoritesGroupName, favoritesIdKey, favoritesVarKey, favoritesDisplayKey, blockSpecialChars }) {

    useRegisterFavorite({ label, favoritesFieldName, favoritesGroupName, favoritesIdKey, favoritesVarKey, favoritesDisplayKey, required })

    const isRequired = required ? required : false
    const ctx = useContext(LoadingContext)
    const [focused, setFocused] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const { t } = useTranslation()

    color = color ? color : ctx.primaryColor ? ctx.primaryColor : 'var(--color-black)'
    secondColor = secondColor ? secondColor : ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)'
    const fieldId = label
    ? `field-${(translate ? t(label) : label).toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')}`
    : 'field-unlabelled'


    function isNumber(e, isInt) {

        //* numbers row, numpad, backspace, minus,  tab, enter, minus, minus, delete, plus
        if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 8 || e.keyCode === 9 || e.keyCode === 13 || e.keyCode === 173 || e.keyCode === 189 || e.keyCode === 46 || e.keyCode === 107 || e.keyCode === 109 || e.keyCode === 171) {
            return true
        }
        if (!isInt) {
            //* comma, period
            if (e.keyCode === 188 || e.keyCode === 190 || e.keyCode === 108 || e.keyCode === 110) {
                return true
            }
        }
        //* ctrl c, ctrl v, ctrlx, arrows
        if ((e.keyCode === 67 && e.ctrlKey) || (e.keyCode === 86 && e.ctrlKey) || (e.keyCode === 88 && e.ctrlKey) || e.keyCode === 37 || e.keyCode === 39) {
            return true
        }
        e.preventDefault()
    }

    const changes = (e) => {

        if (blockSpecialChars) {
            e.target.value = e.target.value.normalize('NFD').replace(/[\u0300-\u036f´`~^¨¸]/g, '');
        }
        
        if (type === 'number' || type === 'decimal') {
            // e.target.value = e.target.value.match(/[+\-]?(?:0|[1-9]\d*)(?:[.,]\d+)?/g)?.join('') || '';
            e.target.value = e.target.value.match(/([+\-]|(?:0|[1-9]\d*)(?:[.,]\d+)?)/g)?.join('') || '';

            /* //Caso queira colocar . e , 
             let newValue = e.target.value

            if (type === 'number' || type === 'decimal') {
                if (ctx.useComma === true) {
                    newValue = newValue.replace(/\./g, ',')
                    newValue = newValue.match(/^[+\-]?\d*(?:,\d*)?/)?.[0] || ''
                } else {
                    newValue = newValue.replace(/,/g, '.')
                    newValue = newValue.match(/^[+\-]?\d*(?:\.\d*)?/)?.[0] || ''
                }
            }
            */
        }
        if (type === 'int') {
            e.target.value = e.target.value.match(/[+\-]?(?:0|[1-9]\d*)/g)?.join('') || '';
        }

        onChange(e)
    }

    function onBlurNumber(e) {
        if (Number(e.replaceAll(',', '.')) || Number(e.replaceAll(',', '.')) === 0) {
            return true
        }
        return false
    }

    const styles = {
        // height: height,
        ...style,
        margin: margin,
        width: size ? size : null,
        '& .fav-star-btn': { opacity: 0, transition: 'opacity 0.15s' },
        '&:hover .fav-star-btn': { opacity: 1 },
        // '&.MuiInput-sizeSmall': {padding:'0px'},
        '& label': { color: secondColor ? secondColor : 'var(--color-black)', },
        '& label.Mui-focused': { color: secondColor ? secondColor : 'var(--color-black)' },
        '& .MuiInput-underline:after': { borderBottomColor: color ? color : 'var(--color-black)' },
        "& .MuiInputBase-root.Mui-disabled": {
            "& > fieldset": {
                borderColor: disabledColor ? disabledColor : 'rgba(0, 0, 0, 0.38) !important'
            }
        },
        '& .MuiOutlinedInput-input': {
            backgroundColor: backgroundColor ? backgroundColor : 'var(--color-white)',
            padding: padding,
            paddingLeft: paddingLeft,
            paddingRight: paddingRight,
            paddingTop: paddingTop,
            paddingBottom: paddingBottom,

        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: color ? color : 'var(--color-black)',
                width: size ? size : null,
                height: height,
            },
            '&:hover fieldset': {
                borderColor: color ? color : 'var(--color-black)',
            },
            '&.Mui-focused fieldset': {
                borderColor: color ? color : 'var(--color-black)',
                boxShadow: `2px 2px 2px ${color}`
            },
            "& legend": {
                letterSpacing: -1.9,
            }
        },
    }

    function adornments() {
        return {
            startAdornment: (!disabled && iconStart || ''),
            endAdornment: (!disabled && iconEnd || type === 'password' ?
                <IconButton
                    disableRipple
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword((prev => !prev))}
                    edge="end"
                    sx={{
                        "&.Mui-focusVisible": {
                            color: "var(--color-black)",
                            backgroundColor: "var(--color-grey-light)"
                        },
                    }}
                >
                    {showPassword ? <VisibilityOff style={{ color: 'var(--color-grey)' }} /> : <Visibility style={{ color: 'var(--color-grey)' }} />}
                </IconButton> : '')
        }
    }

    const autocompleteTextField = useMemo(() => {
        return (
            <Autocomplete
                id="combo-box-demo"
                options={options || []}
                sx={styles}
                draggable={false}
                getOptionLabel={(e) => {
                    let resultString = ''
                    labelFields?.forEach(obj => {
                        //resultString = resultString.concat(` ${e[obj] || ''}`)
                        resultString = resultString.concat(` ${e[obj] ?? ''}`)
                    })
                    return resultString
                }}
                getOptionKey={(e) => e.Id}
                filterOptions={filterOptions}
                renderOption={renderOption}
                value={value}
                onChange={!disabled ? onChangeValue : undefined} // 🔒 impede alteração se estiver desativado
                readOnly={disabled}
                disabled={disabled}
                clearIcon={null} // 🔒 remove o "X"
                forcePopupIcon={!disabled} // 🔒 não mostra o ícone dropdown
                disableClearable={disabled} // 🔒 impede limpar valor com o X ou tecla delete
                onOpen={onOpen}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        draggable={false}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            ...params.InputProps,
                            ...InputProps,
                            readOnly: disabled,
                            endAdornment: (
                                <>
                                    {params.InputProps.endAdornment}
                                    {endAdornment}
                                </>
                            )
                        }}
                        inputProps={{ ...params.inputProps, autoComplete: 'new-password', readOnly: disabled }}
                        onChange={onChange}
                        margin="dense"
                        required={isRequired}
                        label={translate && t(label) || label}
                        variant="outlined"
                        style={{ height: height, textOverflow: 'ellipsis' }}
                        sx={styles}
                        size="small"
                        id={fieldId}
                        disabled={disabled}
                    />
                )}
            />
        )
    }, [options, value, labelFields, onChangeValue, onChange, isRequired, label, styles, height, disabled, renderOption, endAdornment, onOpen, filterOptions, blockSpecialChars, fieldId])


    const textField = useMemo(() => {
        return <TextField
            sx={styles}
            placeholder={placeholder}
            InputLabelProps={{ shrink: true }}
            inputProps={{ maxLength: maxNumbers }}
            InputProps={adornments()}
            draggable={false}
            required={isRequired}
            margin="dense"
            label={translate && t(label) || label}
            variant="outlined"
            fullWidth
            type={type === 'number' ? 'string' : type === 'password' ? showPassword ? "text" : "password" : type}
            disabled={disabled}
            value={label === 'Temperature' ? value > 0 ? (value) && !value.toString()?.includes('+') ? `+${value}` : value : value : value}
            onChange={changes}
            className={className}
            onBlur={(e) => {

                if (!type || type?.toLowerCase() !== 'number') {
                    e.target.value = e.target.value.trim()
                }
                if (type === 'number') {
                    if (onBlurNumber(e.target.value)) {
                        onChange(e)
                    } else {
                        if (e.target.value !== '') {
                            e.target.value = ''
                            onChange(e)
                            ctx.toastMessages('error', t('OnlyNumbers'), '')
                        }
                    }
                } else {
                    onChange(e)
                }
                if (onBlur) {
                    onBlur()
                }
            }}
            onFocus={() => setFocused(true)}
            onKeyDown={(e) => {
                if (e.key === 'Escape') {
                    setFocused(false)
                    cancel && cancel()
                } else if (e.key === 'Enter') {
                    setFocused(false)
                    submit && submit()
                }
                if (onKeyDown) {
                    onKeyDown(e)
                }
                if (type === "number" || type === "int") {
                    isNumber(e, type === 'int' && true)
                }
            }}
            style={{ height: height }}
            size="small"
            id={fieldId}
        />
    }, [styles, placeholder, maxNumbers, isRequired, translate, label, type, disabled, value, onChange, className, onBlur, cancel, submit, height, onKeyDown, blockSpecialChars, fieldId])

    return (
        <>{options ?
            <>
                {autocompleteTextField}
            </>
            :
            <>
                {textField}
            </>
        }
        </>
    )
}